import { getCopiedPassengerKey } from "./mapOrderPassengerToBookingTraveler";

export const COPIED_PASSENGERS_STORAGE_KEY = "flightCopiedPassengers";

export function getCopiedPassengers() {
  try {
    const data = localStorage.getItem(COPIED_PASSENGERS_STORAGE_KEY);
    const parsed = data ? JSON.parse(data) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function setCopiedPassengers(passengers) {
  localStorage.setItem(
    COPIED_PASSENGERS_STORAGE_KEY,
    JSON.stringify(passengers),
  );
}

export function addCopiedPassengerToStorage(passenger) {
  if (!passenger) return false;

  const passengers = getCopiedPassengers();
  const key = getCopiedPassengerKey(passenger);
  const exists = passengers.some(
    (item) => getCopiedPassengerKey(item) === key,
  );

  if (exists) return false;

  setCopiedPassengers([passenger, ...passengers]);
  return true;
}

export function removeCopiedPassengerFromStorage(passengerId) {
  setCopiedPassengers(
    getCopiedPassengers().filter((passenger) => passenger?._id !== passengerId),
  );
}
